import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';
import { getOneClickPreloadedOrder } from './one-click-profiles.selector';
import { getOneClickSelectedProduct } from './one-click-products.selector';

export const getOneClickUnitsState = createSelector(getOneClickState, state => state.unitsSate);

export const getOneClickUnits = createSelector(getOneClickUnitsState, state => state.unitsAvailable);

export const getOneClickUnitsSelected = createSelector(getOneClickUnitsState, state => state.selected);

export const unitWithPreloaded = (index: number) =>
  createSelector(
    getOneClickUnits,
    getOneClickPreloadedOrder,
    getOneClickSelectedProduct(index),
    (units, preloadedOrder, productSelected) => ({ units, preloadedOrder, productSelected }),
  );
